module.exports = __webpack_public_path__ + "static/media/rnr-image-3.6c729958.png";